import { atom } from 'recoil';

interface IdentificationInfo {
    cpr: string;
    zipCode: string;
}

export const identificationAtom = atom<IdentificationInfo>({
    key: 'identificationAtom',
    default: {
        cpr: '',
        zipCode: ''
    }
});
